import styled from "styled-components"

export interface StyledFooterProps {
    legacy: boolean
}

export const StyledFooter = styled.div`
`
export const StyledFooterContainer = styled.div<StyledFooterProps>`
    ${props => !props.legacy && (`
        ${props.theme.mixins.container}
    `)}
`
